import { jsxs as e, jsx as l } from "react/jsx-runtime";
const r = () => /* @__PURE__ */ e(
  "svg",
  {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ l("rect", { width: "18", height: "18", rx: "6", fill: "var(--plac-lines-default)" }),
      /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.28131 5.22052C5.98841 4.92763 5.51354 4.92763 5.22065 5.22052C4.92775 5.51342 4.92775 5.98829 5.22065 6.28118L7.93946 9L5.22065 11.7188C4.92775 12.0117 4.92775 12.4866 5.22065 12.7795C5.51354 13.0724 5.98841 13.0724 6.28131 12.7795L9.00012 10.0607L11.7189 12.7795C12.0118 13.0724 12.4867 13.0724 12.7796 12.7795C13.0725 12.4866 13.0725 12.0117 12.7796 11.7188L10.0608 9L12.7796 6.28118C13.0725 5.98829 13.0725 5.51342 12.7796 5.22052C12.4867 4.92763 12.0118 4.92763 11.7189 5.22052L9.00012 7.93934L6.28131 5.22052Z",
          fill: "var(--plac-primary-gray)"
        }
      )
    ]
  }
);
export {
  r as ChipCloseIcon
};
//# sourceMappingURL=index.es815.js.map
